import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";

export default function FAQ({ items = [], title = "Domande Frequenti", eyebrow = "FAQ" }) {
    const [open, setOpen] = useState(0);
    return (
        <section
            data-testid="faq"
            className="relative py-20 md:py-28 bg-ivory-warm"
        >
            <div className="mx-auto max-w-[1200px] px-6 md:px-12 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-4">
                    <SectionLabel text={eyebrow} />
                    <h2 className="mt-5 font-display text-[32px] md:text-[44px] leading-[1.08] text-ink">
                        {title}
                    </h2>
                    <p className="mt-5 text-ink-soft text-[16px] leading-relaxed max-w-sm">
                        Qui trovi le risposte alle domande più comuni. Per ogni
                        dubbio siamo a disposizione al telefono.
                    </p>
                </div>
                <div className="lg:col-span-8">
                    <ul className="divide-y divide-line">
                        {items.map((it, i) => {
                            const isOpen = open === i;
                            return (
                                <li key={i} data-testid={`faq-item-${i}`}>
                                    <button
                                        onClick={() =>
                                            setOpen(isOpen ? -1 : i)
                                        }
                                        className="w-full flex items-start gap-5 py-5 text-left group"
                                    >
                                        <span className="text-ink-muted text-[15px] md:text-[17px] tabular-nums font-semibold mt-1">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <span className="flex-1 font-display text-[20px] md:text-[24px] leading-tight text-ink group-hover:text-raspberry transition-colors">
                                            {it.q}
                                        </span>
                                        <span
                                            className={`shrink-0 mt-1 w-9 h-9 rounded-full grid place-items-center transition-all duration-150 ${
                                                isOpen
                                                    ? "bg-raspberry text-ivory rotate-45"
                                                    : "bg-white text-ink border border-line"
                                            }`}
                                        >
                                            <Plus size={16} />
                                        </span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{
                                                    height: 0,
                                                    opacity: 0,
                                                }}
                                                animate={{
                                                    height: "auto",
                                                    opacity: 1,
                                                }}
                                                exit={{
                                                    height: 0,
                                                    opacity: 0,
                                                }}
                                                transition={{
                                                    duration: 0.14,
                                                    ease: [0.16, 1, 0.3, 1],
                                                }}
                                                className="overflow-hidden"
                                            >
                                                <div className="pl-11 pr-14 pb-6 text-ink-soft text-[16px] leading-relaxed">
                                                    {it.a}
                                                </div>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
}
